import React from 'react';
import { MdAttachFile } from 'react-icons/md';

function MdAttachFile45degComponent({ size }) {
  return <MdAttachFile style={{ transform: 'rotateZ(45deg)' }} size={size} />;
}

export const MdAttachFile45deg = MdAttachFile45degComponent;
